import { CommonModule } from '@angular/common';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbButtonsModule, NgbDatepickerModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { SelectModule } from '@cmps/ng-select';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { PerformanceDataService } from '../performance-data/performance-data.service';

import { CustomizeInsightComponent } from './customize.insight.component';
import { InsightEpicBridge } from './insight.epic.bridge';
import { TranslationIdMap } from './insight.i18n';
import { InsightService } from './insight.service';
import { LegendInsightComponent } from './legend.insight.component';
import { PathInsightComponent } from './path.insight.component';
import { PeriodInsightComponent } from './period.insight.component';
import { PersistInsightComponent } from './persist.insight.component';
import { PopUpComponent, PopUpService } from './pop-up.service';
import { PresentationInsightComponent } from './presentation.insight.component';
import { RolloverInsightComponent } from './rollover.insight.component';
import { SelectedVisualItemInsightComponent } from './selected-visual-item.insight.component';
import { SelectionCollapseInsightDirective } from './selection-collapse.insight.directive';
import { SelectionSummaryInsightComponent } from './selection-summary.insight.component';
import { VisualItemInsightComponent } from './visual-item.insight.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbButtonsModule,
        NgbDatepickerModule,
        SelectModule,
        NgChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsIconModule,
    ],
    declarations: [
        PopUpComponent,
        PersistInsightComponent,
        PeriodInsightComponent,
        LegendInsightComponent,
        SelectionCollapseInsightDirective,
        SelectionSummaryInsightComponent,
        VisualItemInsightComponent,
        RolloverInsightComponent,
        SelectedVisualItemInsightComponent,
        PresentationInsightComponent,
        PathInsightComponent,
        CustomizeInsightComponent,
    ],
    exports: [
        CmpsCommonModule,
        PersistInsightComponent,
        PeriodInsightComponent,
        LegendInsightComponent,
        SelectionCollapseInsightDirective,
        SelectionSummaryInsightComponent,
        VisualItemInsightComponent,
        SelectedVisualItemInsightComponent,
        PresentationInsightComponent,
        PathInsightComponent,
        CustomizeInsightComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsInsightModule {
    static forRoot(): ModuleWithProviders<CmpsInsightModule> {
        return {
            ngModule: CmpsInsightModule,
            providers: [
                PerformanceDataService,
                InsightService,
                InsightEpicBridge,
                PopUpService,
            ],
        };
    }
}
